import React from 'react';

const MyAlbumsAndTimelines = props => (
  <div className="thumbnails covers d-flex flex-nowrap justify-content-center">
    <button
      className="thumbnail_ album-cover"
      style={{ backgroundImage: `url(${props.myAlbumsCover})` }}
      aria-label="My Albums"
      onClick={props.onMyAlbumsClick}
    >
      <div className="caption text-truncate">My Albums</div>
    </button>
    <button
      className="thumbnail_ album-cover"
      style={{ backgroundImage: `url(${props.timelinesCover})` }}
      aria-label="Timelines"
      onClick={props.onTimelinesClick}
    >
      <div className="caption text-truncate">Timelines</div>
    </button>
  </div>
);

export default MyAlbumsAndTimelines;
